import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from 'angular5-toaster/dist';
import { Observable } from 'rxjs';
import { SurveyQuestionModel } from '../../../../../models/survey/survey.model';
import { ValidationService } from '../../../../../shared/components/control-messages/validation.service';
import { WordCloudSettingsService } from '../../../../settings/word-cloud-settings/word-cloud-settings.service';

@Component({
  selector: 'app-question-exception-words',
  templateUrl: './question-exception-words.component.html',
  styleUrls: ['./question-exception-words.component.less']
})
export class QuestionExceptionWordsComponent implements OnInit {
  @Output() infoChange = new EventEmitter<boolean>();
  @Input() questionId: number;
  @Input() questionText: string;
  @Output() showLoader: boolean;
  @Input() showSetting: boolean;
  exceptionWordStr: string;

  selectorSize = 30;
  exceptionWords: string[];
  newWord: string;
  cloudSettingForm: FormGroup;
  exceptionWordFromGlobalStr: string;
  exceptionValue: string;
  reducer = (accumulator, currentValue) => accumulator + '\n' + currentValue;
  isSaving: boolean;
  constructor(protected fb: FormBuilder, private wordCloudSettingsService: WordCloudSettingsService,
    private toast: ToasterService) {
    this.cloudSettingForm = this.fb.group({
      exceptionWords: ['', Validators.compose([ValidationService.specialCharacterValidator])],
    });

  }

  ngOnInit() {
    this.getQuestionCloudSetting(this.questionId);

    this.getGlobalCloudSetting();
  }
  closeModal() {
    this.showSetting = false;
    this.infoChange.emit(false);
  }

  getGlobalCloudSetting(): any {
    this.wordCloudSettingsService.getGlobalCloudSetting().subscribe(res => {
      this.exceptionWordFromGlobalStr = res.exceptionWords;
      return res.exceptionWords;
    }, _ => {
      // this.toast.pop('error', 'Something went wrong');
    });

  }
  getQuestionCloudSetting(questionId: number) {
    this.wordCloudSettingsService.getQuestionCloudSetting(questionId).subscribe(res => {
      this.exceptionWordStr = res.exceptionWord;
      if (this.exceptionWordStr) {
        this.exceptionWords = this.exceptionWordStr.split(',');
        this.exceptionValue = this.exceptionWords.reduce(this.reducer);
        this.updateForm(this.exceptionValue);
      }
    }, _ => {
      // this.toast.pop('error', 'Something went wrong');
    });
  }

  updateForm(setting: string): void {
    this.cloudSettingForm.patchValue({
      exceptionWords: this.cloudSettingForm.get(['exceptionWords'])!.value === '' ? setting : this.cloudSettingForm.get(['exceptionWords'])!.value + '\n' + setting,
    })
  }
  copyFromGlobal(): void {
    if (this.exceptionWordFromGlobalStr) {
      let updateValue = '';
      this.exceptionWords = this.exceptionWordFromGlobalStr.split(',');
      this.exceptionValue = this.cloudSettingForm.get(['exceptionWords'])!.value;
      if (this.exceptionValue && this.exceptionValue.length > 0) {
        const currentValue = this.exceptionValue.split('\n');
        const filteredArray = this.exceptionWords.filter(value => !currentValue.includes(value));

        if (filteredArray && filteredArray.length > 0) {
          updateValue = filteredArray.reduce(this.reducer);
          this.updateForm(updateValue);
        }
      } else {
        this.exceptionValue = this.exceptionWords.reduce(this.reducer);
        this.updateForm(this.exceptionValue);
      }
    }
  }
  saveSetting(): void {
    this.isSaving = true;
    const settingExceptionWord = this.createFromForm();
    this.subscribeToSaveResponse(this.wordCloudSettingsService.updateQuestionCloudSetting(settingExceptionWord));
  }
  protected subscribeToSaveResponse(result: Observable<HttpResponse<SurveyQuestionModel>>): void {
    result.subscribe(
      () => this.onSaveSuccess(),
      () => this.onSaveError()
    );
  }
  protected onSaveSuccess(): void {
    this.toast.pop('success', 'Update successful!');
    this.isSaving = false;
    this.closeModal();
  }

  protected onSaveError(): void {
    this.toast.pop('error', 'Something went wrong');
    this.isSaving = false;
  }
  createFromForm() {
    const surveyQuestion = new SurveyQuestionModel();
    surveyQuestion.id = this.questionId;
    surveyQuestion.exceptionWord = this.formateString(this.cloudSettingForm.get(['exceptionWords'])!.value);
    return surveyQuestion;
  }
  formateString(str) {
    let strArray = str.split("\n");
    strArray = strArray.filter((item) => {
      return item !== '';
    });
    return strArray.join(",").split(",,").join(",");
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/questions-tab/question-exception-words/question-exception-words.component.ts